import type Client from '../client'
import type {
  ErrorAble,
} from '@/api'

export default class Giftcard {
  constructor(private client: Client) {}

  redeem(
    id: number,
    experienced_at: Date | null = null,
    supplier_id: number | null = null,
    variation_id: number | null = null,
  ): Promise<ErrorAble<unknown>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          await this.client.post('giftcard/redeem', {
            data: { id, experienced_at, supplier_id, variation_id },
          }),
        )
      } catch (error) {
        reject(error)
      }
    })
  }

  validate(code: string, search = false): Promise<ErrorAble<unknown>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          await this.client.post('giftcard/validate', {
            data: { code, search },
          }),
        )
      } catch (error) {
        reject(error)
      }
    })
  }

  validateNew(code: string, search = false): Promise<ErrorAble<unknown>> {
    return new Promise(async (resolve, reject) => {
      try {
        resolve(
          await this.client.post('supplier/giftcard/validate', {
            data: { code, search },
          }),
        )
      } catch (error) {
        reject(error)
      }
    })
  }
}
